export const getDateSlug = (date: string): string => {
  if (!date) return '-';
  // date = '21-03-2021 02:00 PM'
  const [, month, year] = date.split(' ')[0].split('-');

  return `${year}/${month}`;
};
